import { Guard } from './guard';

const env = process.env.REACT_APP_CLIENT_ENV || 'development';

export default function CanSignupGuard(): Guard {
  return {
    canActivate: () =>
      ['development', 'development-remote', 'staging', 'production'].includes(
        env
      )
  };
}
